import { render } from "./Cargando.vue?vue&type=template&id=02a2779e&scoped=true"
import script from "./Cargando.vue?vue&type=script&lang=js"
export * from "./Cargando.vue?vue&type=script&lang=js"

import "./Cargando.vue?vue&type=style&index=0&id=02a2779e&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a2779e"]])

export default __exports__